/* LUCA BIONDI - PB - CUSTOM JS */

/// CART INVOICE LOGIC

if (!window.customElements.get('cart-invoice')) {
  window.customElements.define('cart-invoice', class CartInvoice extends HTMLElement {
    static REQUIRED = ['Ragione sociale', 'SDI/PEC'];

    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      // Stacca i campi dal <form action="/cart">: form owner inesistente = mai inviati al checkout
      this.fields.forEach((field) => field.setAttribute('form', 'invoice-detached'));

      this.saveButton = this.querySelector('[data-invoice-save]');
      this.removeButton = this.querySelector('[data-invoice-remove]');

      this.saveButton?.addEventListener('click', this.onButtonClick.bind(this), { signal });
      this.removeButton?.addEventListener('click', this.onRemove.bind(this), { signal });
      this.addEventListener('input', (event) => event.target.setCustomValidity(''), { signal });

      this.hasAttribute('saved') ? this.lock() : this.unlock();
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    get fields() {
      return Array.from(this.querySelectorAll('input[name^="attributes["], textarea[name^="attributes["]'));
    }

    keyOf(field) {
      return field.name.match(/^attributes\[(.+)\]$/)[1];
    }

    lock() {
      this.locked = true;
      this.fields.forEach((field) => field.disabled = true);
      this.saveButton.textContent = 'Modifica dati';
      this.removeButton.hidden = false;
    }

    unlock({ focus = false } = {}) {
      this.locked = false;
      this.fields.forEach((field) => field.disabled = false);
      this.saveButton.textContent = 'Salva';
      this.removeButton.hidden = !this.hasAttribute('saved');
      if (focus) this.fields[0]?.focus();
    }

    onButtonClick() {
      if (this.busy) return;
      this.locked ? this.unlock({ focus: true }) : this.onSave();
    }

    validate() {
      let firstInvalid = null;

      this.fields.forEach((field) => {
        const isEmpty = field.value.trim() === '';
        const isRequired = CartInvoice.REQUIRED.includes(this.keyOf(field));

        field.setCustomValidity(isRequired && isEmpty ? 'Campo obbligatorio' : '');

        if (isRequired && isEmpty && !firstInvalid) firstInvalid = field;
      });

      if (firstInvalid) {
        firstInvalid.reportValidity();
        firstInvalid.focus();
        return false;
      }

      return true;
    }

    async updateCart(attributes) {
      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      }));

      const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes, sections: sectionsToBundle.join(',') })
      });

      if (!response.ok) throw new Error('cart update failed');

      return response.json();
    }

    notify(cart) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'invoice:update', cart }
      }));
    }

    async onSave() {
      if (this.busy) return;
      if (!this.validate()) return;

      this.busy = true;
      this.saveButton.setAttribute('aria-busy', 'true');

      try {
        const attributes = {};
        this.fields.forEach((field) => {
          attributes[this.keyOf(field)] = field.value.trim();
        });

        const cart = await this.updateCart(attributes);

        this.setAttribute('saved', '');
        this.lock();
        await this.closest('cart-note-dialog')?.hide();
        this.notify(cart);
      } catch (error) {
        console.error(error);
      } finally {
        this.busy = false;
        this.saveButton.removeAttribute('aria-busy');
      }
    }

    async onRemove() {
      if (this.busy) return;

      this.busy = true;
      this.removeButton.setAttribute('aria-busy', 'true');

      try {
        if (!window.confirm('Vuoi rimuovere i dati di fatturazione?')) return;

        const attributes = {};
        this.fields.forEach((field) => {
          attributes[this.keyOf(field)] = '';
        });

        const cart = await this.updateCart(attributes);

        this.fields.forEach((field) => {
          field.value = '';
          field.setCustomValidity('');
        });

        this.removeAttribute('saved');
        this.unlock();
        await this.closest('cart-note-dialog')?.hide();
        this.notify(cart);
      } catch (error) {
        console.error(error);
      } finally {
        this.busy = false;
        this.removeButton.removeAttribute('aria-busy');
      }
    }
  });
}

// CART INVOICE LOGIC END HERE